/**
 * The pending number on a queue button or tab. A filled red pill, never plain parenthesised
 * text, so a waiting queue catches the eye without being looked for. Renders nothing at zero —
 * an empty queue needs no badge.
 */
const QueueCountBadge = ({ count }) => {
  const value = Number(count ?? 0);
  if (!value) return null;
  return (
    <span className="ml-1 inline-flex min-h-[20px] min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1.5 py-0.5 text-[11px] font-bold leading-none text-white">
      {value > 99 ? "99+" : value}
    </span>
  );
};

export default QueueCountBadge;
